var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/no-array-index-key */
import { useState } from 'react';
import { useFloating, useHover, safePolygon, useInteractions, FloatingNode, FloatingPortal, useFloatingNodeId, shift, offset, } from '@floating-ui/react';
import style from './HeaderMenuButton.module.scss';
export function HeaderSubMenuButton(_a) {
    var button = _a.button, children = _a.children;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var nodeId = useFloatingNodeId();
    var _c = useFloating({
        nodeId: nodeId,
        placement: 'right-start',
        open: isOpen,
        onOpenChange: setIsOpen,
        middleware: [
            shift(),
            offset({
                crossAxis: -10,
            }),
        ],
    }), x = _c.x, y = _c.y, strategy = _c.strategy, refs = _c.refs, context = _c.context;
    var hover = useHover(context, {
        restMs: 50,
        handleClose: safePolygon(),
    });
    var _d = useInteractions([hover]), getReferenceProps = _d.getReferenceProps, getFloatingProps = _d.getFloatingProps;
    return (_jsxs("div", { children: [_jsx("button", __assign({ className: style.menuButtonLink, type: "button", ref: refs.setReference }, getReferenceProps(), { children: button })), _jsx(FloatingNode, __assign({ id: nodeId }, { children: _jsx(FloatingPortal, { children: isOpen && (_jsx("div", __assign({ className: style.dropdown, ref: refs.setFloating }, getFloatingProps(), { style: {
                            position: strategy,
                            top: y !== null && y !== void 0 ? y : 0,
                            left: x !== null && x !== void 0 ? x : 0,
                            width: 'max-content',
                        } }, { children: children }))) }) }))] }));
}
